export const reResponsiblesExecutConstants = {
  SEND_RERESPONSIBLESEXECUT_REQUEST: 'SEND_RERESPONSIBLESEXECUT_REQUEST',
  SEND_RERESPONSIBLESEXECUT_SUCCESS: 'SEND_RERESPONSIBLESEXECUT_SUCCESS',
  SEND_RERESPONSIBLESEXECUT_FAILURE: 'SEND_RERESPONSIBLESEXECUT_FAILURE'
}